module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"modal__container\" id=\"kids-access\" >\n    <div class=\"modal__wrapper\">\n        <div class=\"modal_header\" style=\"background-image: url('<%= data.kids_interstitial_featured_image_web_app %>')\">\n            <div class=\"control__bar\">\n                <div class=\"button__close\"></div>\n            </div>\n        </div>\n        <div class=\"modal_content\">\n            <div class=\"modal_body\">\n                <h1> <%= data.kids_interstitial_title.toLowerCase() %> </h1>\n\n                <div class=\"modal_checklist\">\n                    <div class=\"checkmark\"></div>\n                    <p><%= data.explainer_line_1 %></p>\n                </div>\n                <div class=\"modal_checklist\">\n                    <div class=\"checkmark\"></div>\n                    <p><%= data.explainer_line_2 %></p>\n                </div>\n                <div class=\"modal_checklist\">\n                    <div class=\"checkmark\"></div>\n                    <p><%= data.explainer_line_3 %></p>\n                </div>\n            </div>\n\n            <div class=\"modal_footer\">\n                <div class=\"modal_cta\">\n                    <button class=\"button\" id=\"cta1\">\n                        <div class=\"button__text\"><%= data.call_to_action_1 %></div>\n                    </button>\n\n                    <button class=\"button terciary\" id=\"cta2\">\n                        <div class=\"button__text\"><%= data.call_to_action_2 %></div>\n                    </button>\n                </div>\n\n                <p><%= data.kids_interstitial_legal_line_1 %> <%= data.kids_interstitial_legal_line_2 %></p>\n            </div>\n        </div>\n\n        \n    </div>\n</div>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@2cb59e36b5bf7aaf8f94b1c47a0dd20d0dd60000_fetch-_alldszparidq76j4op2jq2yhf4/node_modules/cbs-core-ui/src/js/templates/modals/__kidsAccessModal.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; __append("<div class=\"modal__container\" id=\"kids-access\" >\n    <div class=\"modal__wrapper\">\n        <div class=\"modal_header\" style=\"background-image: url('")
    ; __line = 3
    ; __append(escapeFn( data.kids_interstitial_featured_image_web_app ))
    ; __append("')\">\n            <div class=\"control__bar\">\n                <div class=\"button__close\"></div>\n            </div>\n        </div>\n        <div class=\"modal_content\">\n            <div class=\"modal_body\">\n                <h1> ")
    ; __line = 10
    ; __append(escapeFn( data.kids_interstitial_title.toLowerCase() ))
    ; __append(" </h1>\n\n                <div class=\"modal_checklist\">\n                    <div class=\"checkmark\"></div>\n                    <p>")
    ; __line = 14
    ; __append(escapeFn( data.explainer_line_1 ))
    ; __append("</p>\n                </div>\n                <div class=\"modal_checklist\">\n                    <div class=\"checkmark\"></div>\n                    <p>")
    ; __line = 18
    ; __append(escapeFn( data.explainer_line_2 ))
    ; __append("</p>\n                </div>\n                <div class=\"modal_checklist\">\n                    <div class=\"checkmark\"></div>\n                    <p>")
    ; __line = 22
    ; __append(escapeFn( data.explainer_line_3 ))
    ; __append("</p>\n                </div>\n            </div>\n\n            <div class=\"modal_footer\">\n                <div class=\"modal_cta\">\n                    <button class=\"button\" id=\"cta1\">\n                        <div class=\"button__text\">")
    ; __line = 29
    ; __append(escapeFn( data.call_to_action_1 ))
    ; __append("</div>\n                    </button>\n\n                    <button class=\"button terciary\" id=\"cta2\">\n                        <div class=\"button__text\">")
    ; __line = 33
    ; __append(escapeFn( data.call_to_action_2 ))
    ; __append("</div>\n                    </button>\n                </div>\n\n                <p>")
    ; __line = 37
    ; __append(escapeFn( data.kids_interstitial_legal_line_1 ))
    ; __append(" ")
    ; __append(escapeFn( data.kids_interstitial_legal_line_2 ))
    ; __append("</p>\n            </div>\n        </div>\n\n        \n    </div>\n</div>")
    ; __line = 43
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@2cb59e36b5bf7aaf8f94b1c47a0dd20d0dd60000_fetch-_alldszparidq76j4op2jq2yhf4/node_modules/cbs-core-ui/src/js/templates/modals/__kidsAccessModal.tpl"

}